import { NgModule } from '@angular/core';
import { DocumentComponent } from './document/document.component';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatAutocompleteModule, MatDatepickerModule, MatInputModule } from '@angular/material';
import { NgxImgModule } from 'ngx-img';
import { FileUploadDialogComponent } from './dialogs/file-upload-dialog/file-upload-dialog.component';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { BaseDictionaryComponent } from './base-dictionary/base-dictionary.component';
import { ImageBase64UploadComponent } from './image-base64-upload/image-base64-upload.component';
import { LoggerComponent } from './logger/logger.component';
import { TaskDialogComponent } from './dialogs/task-dialog/task-dialog.component';
import { TaskListComponent } from './task-list/task-list.component';
import { DataYearFilterComponent } from './data-year-filter/data-year-filter.component';
import { MailForwardDialogComponent } from './dialogs/mail-forward-dialog/mail-forward-dialog.component';
import { FinanceObjectLandAdderComponent } from './dialogs/finance-object-land-adder/finance-object-land-adder.component';
import { IncomeObjectsBlockComponent } from './income-objects-block/income-objects-block.component';
import { FinanceObjectCarAdderComponent } from './dialogs/finance-object-car-adder/finance-object-car-adder.component';
import { MatSelectModule } from '@angular/material/select';
import { IncomeObjectAdderComponent } from './income-object-adder/income-object-adder.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FinanceMemberAdderComponent } from './dialogs/finance-member-adder/finance-member-adder.component';
import { BaseContractDictionaryComponent } from './base-contract-dictionary/base-contract-dictionary.component';
import { PhotoBookComponent } from './photo-book/photo-book.component';
import { ComplaintsStatComponent } from './complaints-stat/complaints-stat.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';




@NgModule({
  declarations: [
    DocumentComponent,
    FileUploadDialogComponent,
    BaseDictionaryComponent,
    ImageBase64UploadComponent,
    LoggerComponent,
    TaskDialogComponent,
    TaskListComponent,
    DataYearFilterComponent,
    MailForwardDialogComponent,
    FinanceObjectLandAdderComponent,
    FinanceObjectCarAdderComponent,
    IncomeObjectsBlockComponent,
    IncomeObjectAdderComponent,
    FinanceMemberAdderComponent,
    BaseContractDictionaryComponent,
    PhotoBookComponent,
    ComplaintsStatComponent
  ],
  exports: [
    DocumentComponent,
    BaseDictionaryComponent,
    ImageBase64UploadComponent,
    LoggerComponent,
    TaskListComponent,
    FinanceObjectLandAdderComponent,
    FinanceObjectCarAdderComponent,
    IncomeObjectsBlockComponent,
    IncomeObjectAdderComponent,
    BaseContractDictionaryComponent,
    DataYearFilterComponent,
    PhotoBookComponent,
    ComplaintsStatComponent
  ],
  entryComponents: [
    FileUploadDialogComponent,
    TaskDialogComponent,
    MailForwardDialogComponent,
    FinanceObjectLandAdderComponent,
    FinanceObjectCarAdderComponent,
    FinanceMemberAdderComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    MatInputModule,
    MatDatepickerModule,
    CKEditorModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    NgxImgModule,
    MatListModule,
    MatProgressBarModule,
    MatDialogModule,
    MatSelectModule,
    MatTabsModule,
    MatProgressSpinnerModule
  ]
})
export class SharedLocalModule { }
